import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';

export default function HomePage() {
  const { user, isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) return;

    // If not logged in, kick to login (or trigger Auth0 directly)
    if (!isAuthenticated) {
      navigate('/login', { replace: true });
      return;
    }

    const role = (user as any)?.['https://mitoflux.is/role'];

    // If role missing, send somewhere safe
    if (!role) {
      navigate('/logout', { replace: true });
      return;
    }

    if (role === 'DOCTOR' || role === 'PHARMACIST_LSH') navigate('/doctor', { replace: true });
    else if (role === 'PHARMACIST') navigate('/pharmacist', { replace: true });
    else navigate('/forbidden', { replace: true });
  }, [isLoading, isAuthenticated, user, navigate]);

  return <div style={{ padding: 24 }}>Redirecting…</div>;
}
